export default __webpack_public_path__ + "static/media/effect_three.b137da31.svg";